import React, { useState } from "react";
import axios from '../../axios';
import ModalAlert from '../../redux/components/modal/modal_alert';
import ModalLoader from '../../modal/modal_loader';
import SectionImage from './section_image';
import SectionDetails from './section_details';

const Main = ({
  product,
  setProduct,
  productsImages,
  setProductsImages,
  productsDetails,
  setProductsDetails,
  company,
}) => {
  const modalLoaderRef = React.useRef(null);
  const modalAlertSuccessRef = React.useRef(null);
  const modalAlertDeleteSuccessRef = React.useRef(null);
  const modalAlertDraftSuccessRef = React.useRef(null);
  const modalAlertErrorRef = React.useRef(null);
  const [modalAlertError, setModalAlertError] = React.useState(
    '商品作成に失敗しました。時間をおいてもう一度お試しください。'
  );

  const updateProduct = React.useCallback(() => {
    axios.post(`/api/community/products/update/${product.id}`, product);
  }, [product]);

  const deleteProduct = React.useCallback(() => {
    modalLoaderRef.current.openModal();
    axios
      .post(`/api/community/products/delete/${product.id}`, product)
      .then((response) => {
        modalAlertDeleteSuccessRef.current.openModal();
      })
      .catch((error) => {
        if (error.response.data) {
          setModalAlertError((prev) => error.response.data.error || prev);
        }
        modalAlertErrorRef.current.openModal();
      })
      .finally(() => {
        modalLoaderRef.current.closeModal();
      });
  }, [product]);

  const submitDraft = React.useCallback(() => {
    modalLoaderRef.current.openModal();
    axios
      .post(`/api/community/products/draft/${product.id}`, product)
      .then((response) => {
        modalAlertDraftSuccessRef.current.openModal();
      })
      .catch((error) => {
        if (error.response.data) {
          setModalAlertError((prev) => error.response.data.error || prev);
        }
        modalAlertErrorRef.current.openModal();
      })
      .finally(() => {
        modalLoaderRef.current.closeModal();
      });
  }, [product]);

  const submitPublic = React.useCallback(() => {
    modalLoaderRef.current.openModal();
    axios
      .post(`/api/community/products/public/${product.id}`, product)
      .then((response) => {
        modalAlertSuccessRef.current.openModal();
      })
      .catch((error) => {
        if (error.response.data) {
          setModalAlertError((prev) => error.response.data.error || prev);
        }
        modalAlertErrorRef.current.openModal();
      })
      .finally(() => {
        modalLoaderRef.current.closeModal();
      });
  }, [product]);

  const toMenuPage = React.useCallback(() => {
    modalAlertSuccessRef.current.closeModal();
    modalAlertDraftSuccessRef.current.closeModal();
    modalAlertErrorRef.current.closeModal();
    window.location.href = '/community/' + company.id_to_param + '/admin/products';
  }, []);

  return (
    <div className="container col-lg-8 pt-4">
      <div className="mb-4">
        <p className="pt-2 form-label text-fz-14px text-fw-bold text-black-50">商品名</p>
        <textarea
          id="body"
          className="form-control form-control-lg"
          value={product.title}
          onBlur={updateProduct}
          placeholder={'例) ◯◯パーカー'}
          onChange={(e) => {
            setProduct({
            ...product,
            title: e.target.value,
            });
          }}
        />
      </div>
      <div className="mb-4">
        <p className="pt-2 form-label text-fz-14px text-fw-bold text-black-50">値段</p>
        <input
          id="price"
          className="form-control form-control-lg"
          type="number"
          value={product.price}
          onBlur={updateProduct}
          placeholder={500}
          onChange={(e) => {
            setProduct({
            ...product,
            price: Number(e.target.value),
            });
          }}
        />
      </div>
      <div className="mb-4">
        <p className="pt-2 form-label text-fz-14px text-fw-bold text-black-50">説明文</p>
        <textarea
          id="body"
          className="form-control form-control-lg"
          value={product.description}
          onBlur={updateProduct}
          onChange={(e) => {
            setProduct({
            ...product,
            description: e.target.value,
            });
          }}
        />
      </div>
      <div className="mb-4">
        <p className="pt-2 form-label text-fz-14px text-fw-bold text-black-50">仕様</p>
        <textarea
          id="body"
          className="form-control form-control-lg"
          value={product.specification}
          onBlur={updateProduct}
          onChange={(e) => {
            setProduct({
            ...product,
            specification: e.target.value,
            });
          }}
        />
      </div>
      <div className="mb-4">
        <p className="pt-2 form-label text-fz-14px text-fw-bold text-black-50">注意</p>
        <textarea
          id="body"
          className="form-control form-control-lg"
          value={product.precautions}
          onBlur={updateProduct}
          placeholder={'例) 商品画像はイメージです。実際のものとは若干異なる場合がございます。あらかじめご了承ください。'}
          onChange={(e) => {
            setProduct({
            ...product,
            precautions: e.target.value,
            });
          }}
        />
      </div>
      <div className="mb-4">
        <p className="pt-2 form-label text-fz-14px text-fw-bold text-black-50">商品詳細</p>
        <SectionDetails
          product={product}
          company={company}
          productsDetails={productsDetails}
          setProductsDetails={setProductsDetails}
        />
      </div>
      <div className="mb-4">
        <p className="pt-2 form-label text-fz-14px text-fw-bold text-black-50">商品画像</p>
        <SectionImage
          product={product}
          productsImages={productsImages}
          setProductsImages={setProductsImages}
          images={
            productsImages
              .filter(
                (productsImage) =>
                  productsImage.image_url_medium
              )
              .slice(0, 10) || []
          }
        />
      </div>
      <div className="d-flex mt-4 justify-content-center">
        <div className="mr-4" style={{ width: '35%'}}>
          <div className="">
            <button
              type="button"
              className="my-4 w-100 p-2 text-fw-bold button-color-freemium"
              style={{ maxWidth: '400px' }}
              value="submit_button_for_product"
              onClick={submitDraft}
            >
              下書きを作成
            </button>
          </div>
        </div>
        <div className="ml-4" style={{ width: '35%'}}>
          <div>
            <button
              type="button"
              className="my-4 w-100 p-2 text-fw-bold button-color-freemium"
              style={{ maxWidth: '400px' }}
              value="submit_button_for_product"
              onClick={submitPublic}
            >
              商品を公開
            </button>
          </div>
        </div>
      </div>
      <div className="text-center pb-4">
        <button
          type="button"
          className="border-none my-4 w-100 p-2 text-fw-bold button-color-freemium"
          style={{ maxWidth: '400px' }}
          value="submit_button_for_product"
          onClick={deleteProduct}
        >
          この商品を削除する
        </button>
      </div>
      <ModalAlert
        ref={modalAlertSuccessRef}
        id="modalAlertSuccess"
        title="商品公開完了"
        content="商品を公開しました。"
        approveFunc={() => {
          toMenuPage();
        }}
      />
      <ModalAlert
        ref={modalAlertDeleteSuccessRef}
        id="modalAlertDraftSuccess"
        title="削除完了"
        content="商品を削除しました。"
        approveFunc={() => toMenuPage()}
      />
      <ModalAlert
        ref={modalAlertDraftSuccessRef}
        id="modalAlertDraftSuccess"
        title="下書き商品作成完了"
        content="下書き商品を作成しました。"
        approveFunc={() => toMenuPage()}
      />
      <ModalAlert
        ref={modalAlertErrorRef}
        id="modalAlertError"
        title="商品公開失敗"
        content={modalAlertError}
        approveFunc={() =>
          setTimeout(
            () =>
              setModalAlertError(
                '商品公開に失敗しました。時間をおいてもう一度お試しください。'
              ),
            1000
          )
        }
      />
      <ModalLoader ref={modalLoaderRef} />
    </div>
  );
};

export default Main;
